"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnitConversion = void 0;
const common_1 = require("@saffron/common");
const regex = /^\s*\(([^)]+)\)\s*(.+)/;
const empty = {
    first: null,
    second: null,
};
exports.getUnitConversion = (ig) => {
    if (!ig.name) {
        return empty;
    }
    const m = regex.exec(ig.name);
    if (!m) {
        return empty;
    }
    const newIg = common_1.parseIngredient(m[1]);
    if (newIg.amount && newIg.unit) {
        return {
            first: Object.assign(Object.assign({}, ig), { amount: ig.amount, unit: ig.unit, name: m[2] }),
            second: Object.assign(Object.assign({}, ig), { amount: newIg.amount, unit: newIg.unit, name: m[2] }),
        };
    }
    return empty;
};
//# sourceMappingURL=getUnitConversion.js.map